module.exports = __webpack_public_path__ + "img/16ne.8c5e8f34.svg";